import { get, post } from "utils/request"
import store from "store"
import { createAction, SET_UNREAD_NOTIFICATIONS } from "store/ActionTypes"

export async function getNotifications(page: number = 1) {
  const data = await get(`/notifications?page=${page}&page_size=5`, {})
  return data
}
export async function hasUnread() {
  const data = await get(`/notifications/statistics`, {})
  return data
}

export async function refreshUnreadStatus() {
  try {
    const res = await hasUnread()
    if (res.code === 0) {
      store.dispatch(createAction(SET_UNREAD_NOTIFICATIONS, res.notification_number > 0))
    }
  } catch (error) {
    // 
  }
}

export async function readNotification(id: string) {
  const options = {
    body: {
      notification_id: id
    }
  }
  const data = await post('/notifications/read', options)
  return data
}

export async function readAllNotifications() {
  const data = await post('/notifications/read-all', {})
  return data
}
